import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import noop from 'lodash/noop';

import { l10n } from '@ott/l10n';
import Modal from '@ott/modal';
import { limiter } from '@ott/superagent';
import KM from '@ott/utility-km';

import { GoogleOAuthProvider } from '@react-oauth/google';

import ForgotPasswordForm from './blocks/ForgotPasswordForm';
import SigninForm from './blocks/SigninForm';
import SignupForm from './blocks/SignupForm';
import {
  FORGOT_PASSWORD_FORM_NAME,
  SIGN_IN_FORM_NAME,
  SIGN_UP_FORM_NAME,
  GOOGLE_OAUTH_CLIENT_ID,
} from './constants';

const Auth = ({ onClose, formType, reqHost, withSocialAuth, childrenClassNames }) => {
  const [currenFormType, setFormType] = useState(formType);
  const { isCaptchaShown } = useSelector(limiter.captchaSelector);
  const { preventUserCloseModal } = useSelector((state) => state.common.authModal);

  useEffect(() => {
    KM('Auth_Popup_Login_Show', {
      obj: {
        link: window.location.pathname,
        presetInfo: false,
        type: formType,
      },
    });
  }, []);

  const setSignInForm = () => {
    KM('Auth_Popup_Email_Click');
    setFormType(SIGN_IN_FORM_NAME);
  };
  const setSignUpForm = () => setFormType(SIGN_UP_FORM_NAME);
  const setForgotPasswordForm = () => {
    KM('Auth_Popup_ForgotPwd_Click');
    setFormType(FORGOT_PASSWORD_FORM_NAME);
  };

  let formNode;
  let formTitle;

  switch (currenFormType) {
    case SIGN_IN_FORM_NAME:
      formNode = (
        <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
          <SigninForm
            reqHost={reqHost}
            onForgotPass={setForgotPasswordForm}
            requestSignup={setSignUpForm}
            withSocialAuth={withSocialAuth}
          />
        </GoogleOAuthProvider>
      );
      formTitle = l10n('auth.registered');
      break;
    case SIGN_UP_FORM_NAME:
      formTitle = l10n('auth.signUp');
      formNode = <SignupForm reqHost={reqHost} requestSignin={setSignInForm} onClose={onClose} />;
      break;
    case FORGOT_PASSWORD_FORM_NAME:
      formTitle = l10n('auth.forgotPasswordTitle');
      formNode = <ForgotPasswordForm reqHost={reqHost} onClose={onClose} />;
      break;
    default:
      formTitle = '';
      formNode = null;
  }

  const modalProps = isCaptchaShown
    ? {
        preventUserClose: true,
        closeOnOutsideClick: false,
        closeOnEsc: false,
      }
    : null;

  return (
    <Modal
      {...modalProps}
      preventUserClose={preventUserCloseModal}
      isOpen={true}
      onClose={onClose}
      layoutContainerClassName={childrenClassNames.modalLayoutContainerClassName}
      overlayClassName={childrenClassNames.modalOverlayClassName}
      contentOptions={{
        className: childrenClassNames.modalContentClassName,
        title: formTitle,
      }}
    >
      {formNode}
    </Modal>
  );
};

Auth.propTypes = {
  onClose: PropTypes.func,
  formType: PropTypes.string,
  reqHost: PropTypes.string,
  withSocialAuth: PropTypes.bool,
  childrenClassNames: PropTypes.shape({
    modalLayoutContainerClassName: PropTypes.string,
    modalOverlayClassName: PropTypes.string,
    modalContentClassName: PropTypes.string,
  }),
};

Auth.defaultProps = {
  onClose: noop,
  formType: SIGN_IN_FORM_NAME,
  reqHost: '',
  withSocialAuth: true,
  childrenClassNames: {},
};

export default Auth;
